// Autogenerated file
import SidebarMenu from './SidebarMenu.json';

export default {
  ...SidebarMenu,
};
